import React from 'react';
import styled from 'styled-components';
import { Text } from '../../../../components';
import { COLORS, device } from '../../../../constants';
interface KeyPointsListProps {
  list: string[];
}
const KeyPointsList: React.FC<KeyPointsListProps> = ({ list }) => {
  return (
    <ListContainer>
      {list.map((item, index) => (
        <ListItem key={index}>
          <Text text={item} />
        </ListItem>
      ))}
    </ListContainer>
  );
};
const ListContainer = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 10px;
  list-style-type: disc;
  color: ${COLORS.STEP_RED_BORDER};
  padding-left: 20px;
  @media screen and ${device.sm} {
    gap: 0;
  }
`;

const ListItem = styled.li`
  h4 {
    font-size: 18px;
    min-height: 0;
  }
  @media screen and ${device.md} {
    h4 {
      font-size: 14px;
      line-height: 18px;
    }
  }
  @media screen and ${device.sm} {
    h4 {
      font-size: 12px;
      line-height: 14px;
    }
  }
`;
export default KeyPointsList;
